/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{--header-width:var(--logo-width);position:absolute;top:10px;left:10px;width:50px}.header--link[_ngcontent-%COMP%]{display:block}.header--logo[_ngcontent-%COMP%]{touch-action:manipulation}@media only screen and (max-width:50em) and (orientation:portrait){.header[_ngcontent-%COMP%]{top:30px;--header-width:var(--logo-width-mobile);width:var(--logo-width-mobile)}}@media (min-width:768px){.header[_ngcontent-%COMP%]{top:30px;left:30px;width:var(--header-width)}}"];
export { styles as styles };
